/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown>, name: NonNullable<unknown> }} Drastic_Tech_File_Imported_LogInputs */

const en_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} file imported into ${i?.name} event group.`)
};

const fr_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fichier ${i?.format} importe dans le groupe d'evenements ${i?.name}.`)
};

const de_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Datei ${i?.format} wurde in die Ereignisgruppe ${i?.name} importiert.`)
};

const it_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File ${i?.format} importato nel gruppo di eventi ${i?.name}.`)
};

const ru_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Файл ${i?.format} импортирован в группу событий ${i?.name}.`)
};

const es_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archivo ${i?.format} importado al grupo de eventos ${i?.name}.`)
};

const zh_cn2_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将 ${i?.format} 文件导入到 ${i?.name} 事件组中。`)
};

const ja_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} ファイルが ${i?.name} イベント グループにインポートされました。`)
};

const hi_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल को ${i?.name} इवेंट समूह में आयात किया गया।`)
};

const pt_pt2_drastic_tech_file_imported_log = /** @type {(inputs: Drastic_Tech_File_Imported_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O arquivo ${i?.format} foi importado para o grupo de eventos ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "{format} file imported into {name} event group." |
*
* @param {Drastic_Tech_File_Imported_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_file_imported_log = /** @type {((inputs: Drastic_Tech_File_Imported_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_File_Imported_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_file_imported_log(inputs)
	if (locale === "de") return de_drastic_tech_file_imported_log(inputs)
	if (locale === "it") return it_drastic_tech_file_imported_log(inputs)
	if (locale === "ru") return ru_drastic_tech_file_imported_log(inputs)
	if (locale === "es") return es_drastic_tech_file_imported_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_file_imported_log(inputs)
	if (locale === "ja") return ja_drastic_tech_file_imported_log(inputs)
	if (locale === "hi") return hi_drastic_tech_file_imported_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_file_imported_log(inputs)
	return en_drastic_tech_file_imported_log(inputs)
});